import { jsx as _jsx } from "react/jsx-runtime";
export const AuthComponent = () => {
    return _jsx("div", { children: "Loading" });
};
